import Header from "./component/Header";
import DefaultLayoutAdmin from "./component/defaultLayoutAdmin";
import { Client } from "./route/client.route";
import { useLocation } from 'react-router-dom';
import Sidebar from "./component/Sidebar";
import FloatingContact from "./component/FloatingContact";
import { useState } from "react";

const roterAdmin = '/admin'
function App() {
  const location = useLocation();
  const currentPath = location.pathname;
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const isLessonDetailPage = currentPath.includes('/lesson/listening/') || currentPath.includes('/lesson/speaking/');

  if(currentPath?.includes(roterAdmin)) {
    return <DefaultLayoutAdmin />
  } else {
    return (
      <div className="App bg-[#fafafa] min-h-screen">
        <Header onMenuClick={() => setMobileSidebarOpen(true)} />
        <div className="flex">
          <Sidebar mobileOpen={mobileSidebarOpen} onClose={() => setMobileSidebarOpen(false)} />
          <main className="flex-1">
            <Client />
          </main>
        </div>
        {!isLessonDetailPage && <FloatingContact phone={"+84901234567"} />}
      </div>
    );
  }
}

export default App;
